import usdtIcon from 'src/assets/currency/USDT.svg'
import usdcIcon from 'src/assets/currency/USDC.svg'
import busdIcon from 'src/assets/currency/BUSD.svg'
import ethereum from 'src/assets/currency/ETH.svg'

import { ENetworkTypes } from 'src/types'

export const RouterToken = '0x990A78A913deD684966EA37006Cf0A9cDd14923d'

export const networks = {
  '1': {
    networkName: 'ethereum',
    networkType: ENetworkTypes.ETH,
    currencies: {
      USDC: {
        path: ['0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'],
        token: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        decimals: '6',
        icon: usdcIcon
      },
      USDT: {
        path: ['0xdAC17F958D2ee523a2206206994597C13D831ec7'],
        token: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        decimals: '6',
        icon: usdtIcon
      },
      IDAI: {
        path: ['0x6B175474E89094C44Da98b954EedeAC495271d0F'],
        token: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        decimals: '18',
        icon: busdIcon
      },
      BUSD: {
        path: ['0x4Fabb145d64652a948d72533023f6E7A623C7C53'],
        token: '0x4Fabb145d64652a948d72533023f6E7A623C7C53',
        decimals: '18',
        icon: busdIcon
      },
      ETH: {
        path: [
          '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
          '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'
        ],
        token: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
        decimals: '18',
        icon: ethereum
      }
    }
  },
  '11155111': {
    networkName: 'sepolia',
    networkType: ENetworkTypes.SEPOLIA,
    currencies: {
      USDM: {
        path: ['0x34f2c50DBA5e998690C1b5047A74405c2FF2C54F'],
        token: '0x34f2c50DBA5e998690C1b5047A74405c2FF2C54F',
        decimals: '6',
        icon: usdtIcon
      },
      USDT: {
        path: ['0xd9a6efECb042cB0f892EA61006e0f51190526D52'],
        token: '0xd9a6efECb042cB0f892EA61006e0f51190526D52',
        decimals: '12',
        icon: usdtIcon
      },

      ETH: {
        path: [
          '0x305E0ccd817b39C330380cd81FC9d1ace89a3471',
          '0x34f2c50DBA5e998690C1b5047A74405c2FF2C54F'
        ],
        token: '0x305E0ccd817b39C330380cd81FC9d1ace89a3471',
        decimals: '18',
        icon: ethereum
      }
    }
  }
} as Record<
  string,
  {
    networkName: string
    networkType: string
    currencies: Record<string, { path: string[]; token: string; decimals: string; icon: string }>
  }
>

export const Paths = {
  '1': {
    '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48': {
      symbol: 'USDC'
    },
    '0xdAC17F958D2ee523a2206206994597C13D831ec7': {
      symbol: 'USDT'
    },
    '0x4Fabb145d64652a948d72533023f6E7A623C7C53': {
      symbol: 'BUSD'
    },
    '0x6B175474E89094C44Da98b954EedeAC495271d0F': {
      symbol: 'IDAI'
    },
    '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2,0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48': {
      symbol: 'USDC'
    },
    '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2,0xdAC17F958D2ee523a2206206994597C13D831ec7': {
      symbol: 'USDT'
    }
  },
  '11155111': {
    '0x97425CfaDc3f8CcB511Ca95C59f354A9564777b6': {
      symbol: 'USDM'
    },
    '0xd9a6efECb042cB0f892EA61006e0f51190526D52': {
      symbol: 'USDT'
    },
    '0x305E0ccd817b39C330380cd81FC9d1ace89a3471,0x97425CfaDc3f8CcB511Ca95C59f354A9564777b6': {
      symbol: 'ETH'
    },
    '0x305E0ccd817b39C330380cd81FC9d1ace89a3471,0xd9a6efECb042cB0f892EA61006e0f51190526D52': {
      symbol: 'USDT'
    }
  }
} as Record<string, Record<string, { symbol: string }>>
